import Vue from 'vue';
import App from './App.vue';
import store from './store/index.js';
// import SlitherSlider from 'slither-slider';
import 'tailwindcss/tailwind.css';


// vue instance to send events between components
Vue.prototype.$eventBus = Vue.prototype.$eventBus || new Vue

// load saved state
var app = new Vue({
  store: store,
  components: {
    App
  },
  template: '<App></App>'
});

if (process.env.NODE_ENV === 'development') {
  require('../index.html');
}

app.$mount('#ayv-configurator');

// add event listener to allow pre-configuring the configurator
document.getElementById("ayv-container").addEventListener("setstate", function(e) {
    let state = e.detail;

    // app.$destroy();
    // document.getElementById('ayv-container').innerHTML = '';
    // app.$mount('#ayv-configurator');
    store.commit('mergeState', state);
});
